import React, { Component } from 'react';
import ReactTable from 'react-table';
import XLSX from 'xlsx';
import './SessionsTable.css';
import { connect } from 'react-redux';
import { sessionsTableSkeletonScreen } from '../../../SkeletonScreens/SkeletonScreen';
import { actions } from '../../../Reducks/Sessions/index';
import {
  trackAnalyticsFeature,
  trackAnalyticsGenerateReportFeature
} from '../../../Telemetry/Mixpanel/Features/analyticsTracker';
import { XLS } from '../../../Utils/Constants';
import { CHECKBOX, VALUE_ADD } from '../../../Telemetry/Mixpanel/Constants/mixpanelConstants';
import { HeaderSortComponent } from '../../../Scss/Custom/ReactTable/HeaderSortComponent';
import PropTypes from 'prop-types';
import { denormalizeSessions } from '../../../Reducks/Sessions/SessionsUtils';
import {
  attendanceRateFormatter,
  dateFormatter,
  dateSorter,
  dayFormatter,
  daySorter,
  getSessionsData,
  startTimeFormatter,
  startTimeSorter
} from '../../../Utils/TableUtil';
import { NavLink } from 'react-router-dom';
import SimpleSearchBox from '../../../Components/SearchBox/SimpleSearchBox';
import { SessionsTableVisibleColumns } from '../../../Utils/Constants';
import { toggleElement } from '../../../Utils/ArrayUtils';
import { getSessionsTableColumnOptions } from '../../../Components/CheckedMenu/CheckedMenuItemsHelper';
import CheckedMenu from '../../../Components/CheckedMenu/CheckedMenu';
import Menu from '../../../Components/Menu/Menu';
import DownloadIcon from '../../../Components/Buttons/DownloadIcon';
import { getReportTypeMenuItems } from '../../../Components/Menu/MenuItemsHelper';
import { getUnion } from '../../../Utils/ArrayUtils';

export class SessionsTable extends Component {
  static propTypes = {
    uniqueId: PropTypes.string.isRequired,
    focusedSessionKeyInTable: PropTypes.string,
    focusSessionInChart: PropTypes.func,
    includeEngagementColumns: PropTypes.bool,
    mixpanelData: PropTypes.shape({
      action: PropTypes.string.isRequired,
      reportType: PropTypes.string
    }),
    filterSessions: PropTypes.func,
    isBig: PropTypes.bool,
    sessions: PropTypes.object,
    sessionData: PropTypes.object
  };

  constructor(props) {
    super(props);
    this.state = {
      visibleColumns: [
        SessionsTableVisibleColumns.ATTENDANCE_RATE,
        SessionsTableVisibleColumns.DAY,
        SessionsTableVisibleColumns.DATE,
        SessionsTableVisibleColumns.ATTENDANCE_RATE,
        SessionsTableVisibleColumns.REGISTRANT_COUNT,
        SessionsTableVisibleColumns.START_TIME,
        SessionsTableVisibleColumns.ATTENDEE_COUNT
      ]
    };
    this._webinarNameRefs = new Map();
  }

  onClickHandler = updateId =>
    this.setState(prevState => ({ visibleColumns: toggleElement(updateId, prevState.visibleColumns) }));

  componentDidUpdate(prevProps) {
    this.scrollToSessionInTable(
      prevProps ? prevProps.focusedSessionKeyInTable : null,
      this.props.focusedSessionKeyInTable
    );
    if (this.props.modalFlag !== prevProps.modalFlag) {
      const tableId = this.props.modalFlag ? 'sessionsTableInGenerateReports' : 'sesssionsTableInOverview';
      this.props.passingTableId(tableId);
    }
  }

  componentDidMount() {
    if (this.props && this.props.passingTableId) {
      const tableId = this.props.modalFlag ? 'sessionsTableInGenerateReports' : 'sesssionsTableInOverview';
      this.props.passingTableId(tableId);
    }
  }

  static contextTypes = {
    t: PropTypes.func.isRequired
  };

  getHeaders = () => {
    const { t } = this.context;
    const columns = this.getColumns();
    const header = [];
    columns.forEach(({ show, accessor }) => {
      if (show || accessor === SessionsTableAccessor.NAME) {
        switch (accessor) {
          case SessionsTableAccessor.NAME:
            header.push([t('tableHeaderColumns.name'), accessor]);
            break;
          case SessionsTableAccessor.DAY:
            header.push([t('tableHeaderColumns.day'), accessor]);
            break;
          case SessionsTableAccessor.DATE:
            header.push([t('tableHeaderColumns.date'), accessor]);
            break;
          case SessionsTableAccessor.START_TIME:
            header.push([t('tableHeaderColumns.startTime'), accessor]);
            break;
          case SessionsTableAccessor.APPROVED_REGISTRANTS:
            header.push([t('tableHeaderColumns.registrants'), accessor]);
            break;
          case SessionsTableAccessor.ATTENDEES:
            header.push([t('tableHeaderColumns.attendees'), accessor]);
            break;
          case SessionsTableAccessor.ATTENDANCE_RATE:
            header.push([t('tableHeaderColumns.attendanceRate'), accessor]);
            break;
          case SessionsTableAccessor.ENGAGEMENT_COUNT:
            header.push([t('tableHeaderColumns.engagementCount'), accessor]);
            break;
          case SessionsTableAccessor.QANDA_RESPONSE_COUNT:
            header.push([t('tableHeaderColumns.qAndAResponses'), accessor]);
            break;
          case SessionsTableAccessor.POLL_RESPONSE:
            header.push([t('tableHeaderColumns.pollResponses'), accessor]);
            break;
          case SessionsTableAccessor.SURVEY_RESPONSE:
            header.push([t('tableHeaderColumns.surveyResponses'), accessor]);
            break;
          default:
            console.error('unexpected case');
            break;
        }
      }
    });
    return header;
  };

  getRecords = (sessionsData, headers) => {
    const data = [];
    const { filteredKeys } = this.props.sessionData;
    sessionsData.forEach(session => {
      let row = [];
      if (filteredKeys.includes(session.sessionKey)) {
        headers.forEach(element => {
          switch (element) {
            case SessionsTableAccessor.DAY:
              row.push(dayFormatter({ value: session[element] }));
              break;
            case SessionsTableAccessor.DATE:
              row.push(dateFormatter({ value: session[element] }));
              break;
            case SessionsTableAccessor.START_TIME:
              row.push(startTimeFormatter({ value: session[element] }));
              break;
            case SessionsTableAccessor.ATTENDANCE_RATE:
              row.push(attendanceRateFormatter({ value: session[element] }));
              break;
            default:
              row.push(session[element]);
          }
        });
        data.push(row);
      }
    });
    return data;
  };

  exportFile = (sessionsData, id) => {
    const { t } = this.context;
    const { includeEngagementColumns = false } = this.props;
    const fileName = includeEngagementColumns
      ? t('sessions.sessionEnhancementReportName')
      : t('sessions.sessionReportName');
    const headers = this.getHeaders();
    const records = this.getRecords(sessionsData, headers.map(item => item[1]));
    const data = getUnion([headers.map(item => item[0])], records);
    const workBook = XLSX.utils.book_new();
    const dataSheet = XLSX.utils.aoa_to_sheet(data);
    XLSX.utils.book_append_sheet(workBook, dataSheet);
    XLSX.writeFile(workBook, `${fileName}.${id === XLS ? 'xlsx' : 'csv'}`);
  };

  render() {
    const sessions = this.props.sessionData;
    const { fetching, filtering } = this.props.sessions;
    const focusSessionInChart = this.props.focusSessionInChart;
    const filteredSessions = denormalizeSessions(sessions.filteredKeys, sessions.byKey);
    const detailsMenu = getSessionsTableColumnOptions().map(item => {
      return {
        onClick: () => this.onClickHandler(item.id),
        text: item.title,
        id: item.id,
        checked: this.state.visibleColumns.includes(item.id)
      };
    });

    return (
      <div className="sessionsTableSection">
        {this.getSearchBar(detailsMenu, filteredSessions)}
        {fetching || filtering
          ? sessionsTableSkeletonScreen()
          : this.getSessionsTable(filteredSessions, focusSessionInChart)}
      </div>
    );
  }

  getSessionsTable = (filteredSessions, focusSessionInChart) => {
    return (
      <ReactTable
        keyField="sessionKey"
        data={getSessionsData(filteredSessions)}
        columns={this.getColumns()}
        defaultPageSize={filteredSessions.length}
        minRows={5}
        style={{ height: '270px' }}
        showPagination={false}
        className="-highlight"
        defaultSorted={[{ id: 'date', desc: true }]}
        getTrProps={(state, rowInfo) => {
          return {
            onMouseEnter: () => focusSessionInChart(rowInfo.original.sessionKey),
            onMouseLeave: () => focusSessionInChart(null)
          };
        }}
      />
    );
  };

  getSearchBar = (detailsMenu, filteredSessions) => {
    const { mixpanelData } = this.props;
    const { t } = this.context;
    const { isBig, uniqueId } = this.props;
    const detailsDownloadMenu = [];
    const menuDownloadItems = getReportTypeMenuItems();
    const sessionsData = getSessionsData(filteredSessions);
    menuDownloadItems.map(item =>
      detailsDownloadMenu.push({
        onClick: () => this.exportFile(sessionsData, item.id),
        text: item.title,
        iconClassName: item.iconClass,
        id: item.id
      })
    );
    return (
      <div className="searchBoxContainer">
        <SimpleSearchBox
          searchString={this.props.sessions.filter.searchString}
          placeHolder={t('sessions.search')}
          onSearchInputChange={this.handleSearch}
          mixpanelData={mixpanelData}
        />
        <div className="d-flex justify-content-between align-items-center">
          <CheckedMenu
            menuKey={`sessionsTableManageColumns_${uniqueId}`}
            detailsMenu={detailsMenu}
            buttonName={t('sessionDetails.manageColumns')}
            isBig={isBig}
          />
          <Menu
            isBig={isBig}
            menuKey={`download_${uniqueId}`}
            buttonName={t('buttons.downloadCamelCase')}
            detailsMenu={detailsDownloadMenu}
            buttonComponent={<DownloadIcon isBig={isBig} />}
          />
        </div>
      </div>
    );
  };

  handleSearch = value => {
    if (value !== null) {
      this.props.filterSessions({ searchString: value });
    }
  };

  getColumns = () => {
    const { t } = this.context;
    const { filteredSelectedSessionKeys, filteredKeys } = this.props.sessionData;
    const { includeEngagementColumns = false } = this.props;

    const checkBoxColumn = {
      accessor: '',
      Header: this.checkBoxHeaderFormatter(filteredKeys.length, filteredSelectedSessionKeys.length),
      Cell: this.checkBoxCellFormatter,
      sortable: false,
      width: 67,
      resizable: false,
      className: 'stickyCheckBox',
      headerClassName: 'stickyCheckBox',
      style: { textAlign: 'center' },
      headerStyle: { textAlign: 'center' }
    };
    const nameColumn = {
      accessor: SessionsTableAccessor.NAME,
      Header: <HeaderSortComponent headerTitle={t('tableHeaderColumns.name')} />,
      Cell: this.webinarNameFormatter,
      className: 'stickyName',
      headerClassName: 'stickyName',
      minWidth: 200
    };
    const dayColumn = {
      accessor: SessionsTableAccessor.DAY,
      Header: <HeaderSortComponent headerTitle={t('tableHeaderColumns.day')} />,
      show: this.state.visibleColumns.includes(SessionsTableVisibleColumns.DAY),
      Cell: dayFormatter,
      sortMethod: daySorter,
      width: 100
    };
    const dateColumn = {
      accessor: SessionsTableAccessor.DATE,
      Header: <HeaderSortComponent headerTitle={t('tableHeaderColumns.date')} />,
      show: this.state.visibleColumns.includes(SessionsTableVisibleColumns.DATE),
      Cell: dateFormatter,
      sortMethod: dateSorter
    };
    const startTimeColumn = {
      accessor: SessionsTableAccessor.START_TIME,
      Header: <HeaderSortComponent headerTitle={t('tableHeaderColumns.startTime')} />,
      show: this.state.visibleColumns.includes(SessionsTableVisibleColumns.START_TIME),
      Cell: startTimeFormatter,
      sortMethod: startTimeSorter
    };
    const registrantCountColumn = {
      accessor: SessionsTableAccessor.APPROVED_REGISTRANTS,
      Header: <HeaderSortComponent headerTitle={t('tableHeaderColumns.registrants')} />,
      show: this.state.visibleColumns.includes(SessionsTableVisibleColumns.REGISTRANT_COUNT)
    };
    const attendeeCountColumn = {
      accessor: SessionsTableAccessor.ATTENDEES,
      Header: <HeaderSortComponent headerTitle={t('tableHeaderColumns.attendees')} />,
      show: this.state.visibleColumns.includes(SessionsTableVisibleColumns.ATTENDEE_COUNT)
    };
    const attendanceRateColumn = {
      accessor: SessionsTableAccessor.ATTENDANCE_RATE,
      Header: <HeaderSortComponent headerTitle={t('tableHeaderColumns.attendanceRate')} />,
      show: this.state.visibleColumns.includes(SessionsTableVisibleColumns.ATTENDANCE_RATE),
      Cell: attendanceRateFormatter
    };
    const engagementCountColumn = {
      accessor: SessionsTableAccessor.ENGAGEMENT_COUNT,
      Header: <HeaderSortComponent headerTitle={t('tableHeaderColumns.engagementCount')} />,
      show: includeEngagementColumns
    };
    const qAndACountColumn = {
      accessor: SessionsTableAccessor.QANDA_RESPONSE_COUNT,
      Header: <HeaderSortComponent headerTitle={t('tableHeaderColumns.qAndAResponses')} />,
      show: includeEngagementColumns
    };
    const pollResponseCountColumn = {
      accessor: SessionsTableAccessor.POLL_RESPONSE,
      Header: <HeaderSortComponent headerTitle={t('tableHeaderColumns.pollResponses')} />,
      show: includeEngagementColumns
    };
    const surveyResponseCountColumn = {
      accessor: SessionsTableAccessor.SURVEY_RESPONSE,
      Header: <HeaderSortComponent headerTitle={t('tableHeaderColumns.surveyResponses')} />,
      show: includeEngagementColumns
    };

    const defaultColumns = [
      checkBoxColumn,
      nameColumn,
      dayColumn,
      dateColumn,
      startTimeColumn,
      registrantCountColumn,
      attendeeCountColumn,
      attendanceRateColumn
    ];

    const extraColumns = [engagementCountColumn, qAndACountColumn, pollResponseCountColumn, surveyResponseCountColumn];
    return includeEngagementColumns ? [...defaultColumns, ...extraColumns] : defaultColumns;
  };

  checkBoxCellFormatter = ({ original }) => {
    return (
      <input
        type="checkbox"
        ref={c => this._webinarNameRefs.set(original.sessionKey, c)}
        checked={this.props.sessionData.filteredSelectedSessionKeys.includes(original.sessionKey)}
        onChange={e => {
          trackAnalyticsFeature(VALUE_ADD, this.props.mixpanelData.action, CHECKBOX);
          if (this.props.mixpanelData.reportType) {
            trackAnalyticsGenerateReportFeature(this.props.mixpanelData.reportType, CHECKBOX);
          }
          this.props.toggleSession(original.sessionKey, e.target.checked, this.props.uniqueId);
        }}
      />
    );
  };
  webinarNameFormatter = ({ original }) => {
    return <NavLink to={`/analytics/sessions/${original.sessionKey}`}>{original.name}</NavLink>;
  };

  checkBoxHeaderFormatter = (totalCount, selectedCount) => {
    const checked = selectedCount !== 0;
    const isIntermediate = selectedCount !== 0 && selectedCount !== totalCount;
    const onCheck = e => {
      trackAnalyticsFeature(VALUE_ADD, this.props.mixpanelData.action, CHECKBOX);
      if (this.props.mixpanelData.reportType) {
        trackAnalyticsGenerateReportFeature(this.props.mixpanelData.reportType, CHECKBOX);
      }
      this.props.toggleAllSessions(e.target.checked, this.props.uniqueId);
    };
    const intermediate = input => {
      if (input) {
        input.indeterminate = isIntermediate;
      }
    };
    return <input type="checkbox" ref={intermediate} checked={checked} onChange={onCheck} />;
  };

  scrollToSessionInTable = (previousSessionKey, newSessionKey) => {
    if (newSessionKey) {
      const node = this._webinarNameRefs.get(newSessionKey);
      try {
        const row = node.parentElement.parentElement.parentElement;
        const tableBodyNode = row.parentElement;
        tableBodyNode.scrollTop = row.offsetTop - 45;
        const { scrollX, scrollY } = window;
        node.focus({ preventScroll: true });
        window.scrollTo(scrollX, scrollY);

        return this;
      } catch (e) {}
    } else if (previousSessionKey) {
      const node = this._webinarNameRefs.get(previousSessionKey);
      if (node) {
        node.blur();
      }
    }
  };
}

export default connect(
  state => ({ sessions: state.reduced_sessions, modalFlag: state.reduced_reports.isGenerateReportOpen }),
  {
    toggleSession: actions.toggleSession,
    toggleAllSessions: actions.toggleAllSessions,
    filterSessions: actions.filterSessionsByCount,
    passingTableId: actions.postTableId
  }
)(SessionsTable);

class SessionsTableAccessor {
  static get NAME() {
    return 'name';
  }
  static get DAY() {
    return 'day';
  }
  static get DATE() {
    return 'date';
  }
  static get START_TIME() {
    return 'startTime';
  }
  static get APPROVED_REGISTRANTS() {
    return 'registrants';
  }
  static get ATTENDEES() {
    return 'attendees';
  }
  static get ATTENDANCE_RATE() {
    return 'attendanceRate';
  }
  static get ENGAGEMENT_COUNT() {
    return 'engagementCount';
  }
  static get QANDA_RESPONSE_COUNT() {
    return 'qAndAResponseCount';
  }
  static get POLL_RESPONSE() {
    return 'pollResponses';
  }
  static get SURVEY_RESPONSE() {
    return 'surveyResponses';
  }
}



// WEBPACK FOOTER //
// ./src/GoToWebinar/Sessions/Table/SessionsTable.js